// extracted by mini-css-extract-plugin
export default {"scene":"game_scene__qPDCM","mobile":"game_mobile__4cm6F","button":"game_button__8ne3j"};